import { ErrorRoutePath } from "app/constants/routePaths";
import StatusFlagsScreen from "app/screens/statusFlags/StatusFlagsScreen";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { usePermissionCheck } from "app/services/permissions/usePermissionCheck";
import { Redirect } from "expo-router";

export default function StatusFlagPage() {
  const { checkPermission } = usePermissionCheck();

  if (!checkPermission(PermissionsEnums.VIEW_STATUS_FLAG))
    return <Redirect href={ErrorRoutePath} />;

  return <StatusFlagsScreen />;
}
